import { AIChatPlugin } from '@alpod-ai-writer/plate-plugins/ai/react';
import { useEditorPlugin } from '@udecode/plate/react';
import { SparklesIcon } from 'lucide-react';
import type React from 'react';
import { useCallback } from 'react';

import { ToolbarButton } from '../common/toolbar.component';

export const AiToolbarButton: React.FC = () => {
    const { api } = useEditorPlugin(AIChatPlugin);

    const handleClick = useCallback(() => {
        api.aiChat.show();
    }, [ api ]);

    return (
        <ToolbarButton
            onMouseDown={(e) => { e.preventDefault(); handleClick(); }}
            tooltip="Použít AI"
        ><SparklesIcon /></ToolbarButton>
    );
};
